import React from "react";
import Kullanicilar from "../kullanicilar";

export default function HiyerarsikYapi() {
  return <Kullanicilar groups={true} />;
}
